export const SELECT_LANGUAGE_HEIGHT = "280px";
export const NO_SUPPORTED_LANGUAGES = 0;
